/**
 * ActionPlan component - Displays 3-part action plan (Workout/Nutrition/Recovery).
 * Each section shows an icon, category label, and recommendation text.
 */

import React from 'react';
import { ActionPlan as ActionPlanType } from '../../types';

interface ActionPlanProps {
  plan: ActionPlanType;
}

const SECTIONS = [
  { key: 'workout' as const, icon: '💪', label: 'Workout', color: 'border-l-blue-400' },
  { key: 'nutrition' as const, icon: '🥗', label: 'Nutrition', color: 'border-l-green-400' },
  { key: 'recovery' as const, icon: '🛌', label: 'Recovery', color: 'border-l-purple-400' },
];

const ActionPlanDisplay: React.FC<ActionPlanProps> = ({ plan }) => {
  return (
    <div className="space-y-3">
      {SECTIONS.map(({ key, icon, label, color }) => (
        <div
          key={key}
          className={`bg-white border border-neutral-200 ${color} border-l-4 rounded-lg p-4`}
        >
          <div className="flex items-start space-x-3">
            <span className="text-xl flex-shrink-0">{icon}</span>
            <div>
              <div className="text-sm font-semibold text-neutral-800 mb-1">{label}</div>
              <p className="text-neutral-700 text-sm leading-relaxed">{plan[key]}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActionPlanDisplay;
